import { render } from "./PossibleTaxExemptions.vue?vue&type=template&id=0cacd493"
import script from "./PossibleTaxExemptions.vue?vue&type=script&lang=js"
export * from "./PossibleTaxExemptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__